import {
    Component,
    ElementRef,
    NgZone,
    ViewChild,
    Inject,
    Optional,
    OnInit,
    Output,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RoleService } from "app/main/services/roles.service";
import { TranslateService } from "@ngx-translate/core";

import {
    MatAutocompleteSelectedEvent,
    MatAutocomplete,
} from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { SujetoObligado } from "app/main/models/sujeto-obligado.model";
import { TipoSujetoObligado } from "app/main/models/tipo-sujeto-obligado.model";
import { TipoDocumentoService } from "app/main/services/tipo-documento.service";
import { TipoSujetoObligadoService } from "app/main/services/tipo-sujeto-obligado.service";
import { TipoDocumento } from "app/main/models/tipo-documento.model";
import { PaisService } from "app/main/services/pais.service";
import { SectorActividadService } from "app/main/services/sector-actividad.service";
import { ProfesionService } from "app/main/services/profesion.service";
import { PersonaFisica } from "app/main/models/persona-fisica.model";
import { PersonaJuridica } from "app/main/models/persona-juridica.model";
import { Contacto } from "app/main/models/contacto.model";
import { Cliente } from "app/main/models/cliente.model";
import { ClienteGeneralData } from "app/main/models/cliente-general-data.model";
import { ClienteService } from "app/main/services/cliente.service";
import { DocumentoDeIdentidad } from "app/main/models/documento-de-identidad.model";
import { RazonSocial } from "app/main/models/razon-social.model";

@Component({
    selector: "cliente-dialog-box",
    templateUrl: "./dialog-box.component.html",
    styleUrls: ["./dialog-box.component.scss"],
})
export class ClienteDialogBoxComponent {
    @Output() eventoDesdePadre: string;

    tipos = [
        { nombre: "Persona física", value: "PERSONA_FISICA" },
        { nombre: "Persona jurídica", value: "PERSONA_JURIDICA" },
    ];

    displayedColumnsEvaluaciones: string[] = [
        "nombre",
        "estado",
        "version",
        "estructuraJerarquica",
        "creador",
        "dueno",
        "fechaInicio",
        "fechaFin",
    ];

    tipo: string;
    action: string;
    sujetoObligado: SujetoObligado;
    LOCAL_DATA: any;
    razonSocialPais: any;

    GENERAL_DATA: ClienteGeneralData = new ClienteGeneralData({});

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    tiposProfesiones = [];
    paises = [];
    displayedColumns: string[] = ["estructura", "nombre"];

    constructor(
        private roleService: RoleService,
        public dialogRef: MatDialogRef<ClienteDialogBoxComponent>,
        public translate: TranslateService,
        private serviceTipoSujetoObligado: TipoSujetoObligadoService,
        private serviceTipoDocumento: TipoDocumentoService,
        private servicePais: PaisService,
        //private serviceSectorIndustrial: SectorActividadService,
        private serviceProfesion: ProfesionService,
        private clienteService: ClienteService,
        // @Optional() is used to prevent error if no data is passed
        @Optional() @Inject(MAT_DIALOG_DATA) public data: SujetoObligado
    ) {
        console.log(data);
        this.LOCAL_DATA = { ...data };
        this.action = this.LOCAL_DATA.action;
        delete this.LOCAL_DATA["action"];
        this.sujetoObligado = this.LOCAL_DATA.sujetoObligado;
        delete this.LOCAL_DATA["sujetoObligado"];
        if (
            this.LOCAL_DATA == null ||
            Object.keys(this.LOCAL_DATA).length == 0
        ) {
            this.LOCAL_DATA = new Cliente({});
            this.LOCAL_DATA.sujetoObligado = this.sujetoObligado;
        } else {
            this.GENERAL_DATA =
                this.LOCAL_DATA.personaFisica ||
                this.LOCAL_DATA.personaJuridica;
            //Traer el LOCAL_DATA desde la base.
            this.clienteService
                .get(this.LOCAL_DATA.id)
                .pipe()
                .subscribe((req) => {
                    this.LOCAL_DATA = req.body;
                    this.GENERAL_DATA =
                        this.LOCAL_DATA.personaFisica ||
                        this.LOCAL_DATA.personaJuridica;
                    this.tipo = this.LOCAL_DATA.tipo;
                    this.eventoDesdePadre = "¡Hola hijo!";
                    this.GENERAL_DATA.razonSocial = new RazonSocial(
                        this.GENERAL_DATA.razonSocial
                    );
                });
        }
    }

    @ViewChild("usuarioInput") usuarioInput: ElementRef<HTMLInputElement>;
    @ViewChild("auto") matAutocomplete: MatAutocomplete;

    clienteChange(cliente: Cliente) {
        this.LOCAL_DATA = cliente;
    }

    tipoChange(tipo: string) {
        this.tipo = tipo;
    }

    doAction(): void {
        if (this.LOCAL_DATA != null && this.LOCAL_DATA.id == null)
            this.eventoDesdePadre = "¡Hola hijo!";

        if (this.action == "Add") {
            if (this.tipo == "PERSONA_FISICA") {
                this.LOCAL_DATA.personaJuridica = null;
            }

            if (this.tipo == "PERSONA_JURIDICA") {
                this.LOCAL_DATA.personaFisica = null;
            }

            if (this.LOCAL_DATA.tipo == "PERSONA_FISICA") {
                //this.LOCAL_DATA.personaFisica.sectorIndustrial = this.GENERAL_DATA.sectorIndustrial;
                this.LOCAL_DATA.personaFisica.contacto = new Contacto({});

                this.LOCAL_DATA.personaFisica.contacto.addCorreo(
                    this.GENERAL_DATA.correoElectronico
                );
                this.LOCAL_DATA.personaFisica.contacto.addTelefono(
                    this.GENERAL_DATA.telefono
                );
                this.GENERAL_DATA.direccionFisica.tipo = "FISICA";
                this.LOCAL_DATA.personaFisica.contacto.addDireccion(
                    this.GENERAL_DATA.direccionFisica
                );
                this.LOCAL_DATA.personaFisica.documentoIdentidad =
                    new DocumentoDeIdentidad(this.GENERAL_DATA.razonSocial);
            }

            if (this.LOCAL_DATA.tipo == "PERSONA_JURIDICA") {
                //this.LOCAL_DATA.personaJuridica.sectorIndustrial = this.GENERAL_DATA.sectorIndustrial;
                this.LOCAL_DATA.personaJuridica.contacto = new Contacto({});

                this.LOCAL_DATA.personaJuridica.contacto.addCorreo(
                    this.GENERAL_DATA.correoElectronico
                );
                this.LOCAL_DATA.personaJuridica.contacto.addTelefono(
                    this.GENERAL_DATA.telefono
                );
                this.GENERAL_DATA.direccionFisica.tipo = "FISICA";
                this.LOCAL_DATA.personaJuridica.contacto.addDireccion(
                    this.GENERAL_DATA.direccionFisica
                );
                this.GENERAL_DATA.direccionFisica.tipo = "FISCAL";
                this.LOCAL_DATA.personaJuridica.contacto.addDireccion(
                    this.GENERAL_DATA.direccionFiscal
                );
                this.LOCAL_DATA.personaJuridica.razonSocial =
                    new DocumentoDeIdentidad(this.GENERAL_DATA.razonSocial);
            }

            //delete attribut this.LOCAL_DATA.sectorIndustrial;
            this.LOCAL_DATA.sectorIndustrial = null;
        }

        // if(this.action=='Update'){
        //   if(this.tipo=='PERSONA_FISICA'){

        //     this.LOCAL_DATA.personaFisica.sectorIndustrial = this.GENERAL_DATA.sectorIndustrial;

        //     if(this.LOCAL_DATA.personaFisica.contacto==null)
        //       this.LOCAL_DATA.personaFisica.contacto = this.LOCAL_DATA.contacto || new Contacto({});

        //     this.LOCAL_DATA.personaFisica.contacto.addCorreo(this.GENERAL_DATA.correoElectronico);
        //     this.LOCAL_DATA.personaFisica.contacto.addTelefono(this.GENERAL_DATA.telefono);

        //   }

        //   if(this.tipo=='PERSONA_JURIDICA'){
        //     this.LOCAL_DATA.personaJuridica.sectorIndustrial = this.GENERAL_DATA.sectorIndustrial;

        //     if(this.LOCAL_DATA.personaFisica.contacto==null)
        //       this.LOCAL_DATA.personaJuridica.contacto = this.GENERAL_DATA.contacto || new Contacto({});

        //     this.LOCAL_DATA.personaJuridica.contacto.addCorreo(this.GENERAL_DATA.correoElectronico);
        //     this.LOCAL_DATA.personaJuridica.contacto.addTelefono(this.GENERAL_DATA.telefono);
        //     this.LOCAL_DATA.personaJuridica.razonSocial = this.GENERAL_DATA.razonSocial;

        //   }
        // }

        this.dialogRef.close({ event: this.action, data: this.LOCAL_DATA });
    }

    closeDialog(): void {
        this.dialogRef.close({ event: "Cancel" });
    }

    ngOnInit(): void {}

    compareObjects(o1: any, o2: any): boolean {
        var equals = false;
        if (
            o1 != null &&
            o2 != null &&
            typeof o1 === "object" &&
            typeof o2 === "object" &&
            "id" in o1 &&
            "id" in o2 &&
            o1.id === o2.id
        ) {
            equals = true;
        } else {
            equals = o1 == o2 ? true : false;
        }

        return equals;
    }

    openDialog(): void {}
}
